import './App.css';
import { Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import PlogPage from './page/Plog Page/PlogPage';
// import OneOfPlogPage from './page/Plog Page/OneOfPlogPage';
import ShowPlogPage from './page/Plog Page/ShowPlogPage';
import PrivacyPolicy from './page/Privacy Policy/PrivacyPolicy';


// Lazy imports for routes
const Root = lazy(() => import('./page/Root'));
const Pages = lazy(() => import('./page/Pages'));
const AllSectionAbout = lazy(() => import('./page/About Page/AllSectionAbout'));
const OffersPage = lazy(() => import('./page/Offers Page/OffersPage'));
const HeroService = lazy(() => import('./page/Service Page/HeroService'));
const OneService = lazy(() => import('./page/Service Page/OneServiceOfPage/OneService'));
const WorkPage = lazy(() => import('./page/Work Page/WorkPage'));


function App() {

  return (
    <div dir="rtl">
      <Suspense>
        <Routes>
          <Route path="/" element={<Root />}>
            <Route index element={<Pages />} />
            <Route path="about" element={<AllSectionAbout />} />
            <Route path="offers" element={<OffersPage />} />
            <Route path="service" element={<HeroService />} />
            <Route path="service/:text" element={<OneService />} />
            <Route path="work" element={<WorkPage />} />
            <Route path="blog" element={<PlogPage />} />
            <Route path="blog/:id/:text" element={<ShowPlogPage />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
          </Route>
        </Routes>
      </Suspense>
    </div>
  );

}

export default App;
